import type { LocaleEnum } from '../../enums'
import type { Value } from '../csv-generator.utils'

export class CSVValue {
  private value: Value
  private readonly EMPTY_VALUE_PLACEHOLDER = '-'
  private readonly LIST_VALUE_SEPARATOR = ', '
  private readonly MIN_DECIMAL_DIGITS = 2
  private readonly MAX_DECIMAL_DIGITS = 20
  private locale: LocaleEnum

  public constructor(value: Value, locale: LocaleEnum) {
    this.value = value
    this.locale = locale
  }

  toString(): string {
    if (typeof this.value === 'string' && this.value.trim().length > 0) {
      return this.formatString(this.value)
    }

    if (typeof this.value === 'number') {
      return this.formatNumber(this.value)
    }

    if (Array.isArray(this.value) && this.value.length > 0) {
      return this.formatList(this.value)
    }

    return this.EMPTY_VALUE_PLACEHOLDER
  }

  private formatString(str: string): string {
    return `"${str}"`
  }

  private formatNumber(value: number): string {
    if (Number.isInteger(value)) {
      return value.toString()
    }

    return this.formatString(
      value.toLocaleString(this.locale, {
        minimumFractionDigits: this.MIN_DECIMAL_DIGITS,
        maximumFractionDigits: this.MAX_DECIMAL_DIGITS,
      }),
    )
  }

  private formatList(list: string[]): string {
    return this.formatString(list.join(this.LIST_VALUE_SEPARATOR))
  }

  isEmpty(): boolean {
    return this.toString() === this.EMPTY_VALUE_PLACEHOLDER
  }
}
